const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  productInfoLoaded: 'product-info:loaded',
  modalHide: 'modal-hide',
  newsletterActivated: 'newsletter-activated',
};

const SHOPIFY_SYSTEM_PATHS = {
  CHALLENGE: '/challenge',
};

const DESKTOP_WIDTH = 1023;

const DEFAULT_SLIDER_SPEED = 300;

const RELATED_PRODUCT_LIMIT = 15;

const RELATED_PRODUCT_INTENT = 'related';

// Product slider "items per row" settings. A merchant enters whole items,
// optionally with `.1` to also reveal a sliver of the next card. Any fractional
// part resolves to the breakpoint's peek below rather than reaching Swiper
// literally, so 4.1 becomes 4.5 on desktop and 2.1 becomes 2.5 on mobile.
//
// The peek is a fraction of one card, so the sliver it produces shrinks as the
// cards get narrower — at 4.1 on mobile a 0.3 fraction is swallowed whole by the
// edge offset and nothing shows. Higher counts therefore need a larger fraction
// to reveal a comparable amount of the next card. Counts past the last entry
// reuse it, and these are only read when the merchant asked for a peek.
const SLIDES_PER_VIEW_MOBILE_DEFAULTS = {
  fallback: 2.1,
  peekByWholeSlides: { 1: 0.5, 2: 0.5, 3: 0.5, 4: 0.7 },
  offset: 16,
};

const SLIDES_PER_VIEW_DESKTOP_DEFAULTS = {
  fallback: 4.1,
  peekByWholeSlides: { 1: 0.5, 2: 0.5, 3: 0.5, 4: 0.5, 5: 0.55, 6: 0.65, 7: 0.75 },
  offset: 80,
};

function getPeekFraction(peekByWholeSlides, wholeSlides) {
  const highestCount = Math.max(...Object.keys(peekByWholeSlides).map(Number));

  return peekByWholeSlides[Math.min(wholeSlides, highestCount)];
}

// Swiper sizes slides from the container width alone — slidesOffsetBefore is not
// deducted from it — so an offset plus a whole slidesPerView pushes the last card
// past the right edge. With no peek requested the offsets are dropped here and the
// edge inset is applied as wrapper padding instead (slider-inset-generator.liquid).
function getSlidesConfig(configuredValue, { fallback, peekByWholeSlides, offset }) {
  // Anything that isn't a real count of at least one item — blank, text,
  // negative, below one, Infinity — falls back rather than reaching Swiper,
  // where it would size slides to a negative or absurd width.
  const parsedValue = parseFloat(configuredValue);
  const configured =
    Number.isFinite(parsedValue) && parsedValue >= 1 ? parsedValue : fallback;
  const wholeSlides = Math.floor(configured);
  const hasPeek = configured > wholeSlides;
  const peek = getPeekFraction(peekByWholeSlides, wholeSlides);

  return {
    slidesPerView: hasPeek ? wholeSlides + peek : wholeSlides,
    slidesOffsetBefore: hasPeek ? offset : 0,
    slidesOffsetAfter: hasPeek ? offset : 0,
  };
}
